import { Button, Group, Text, ThemeIcon } from '@mantine/core';
import { Check } from 'react-feather';

/**
 * MED-793 / AC11 — "Mark As Reviewed" header control.
 *
 *   Before:  outlined "Mark As Reviewed" button (matches screenshot 5 minus the AI banner)
 *   After:   green-check + "Marked As Reviewed" label, with click-to-undo (matches screenshot 6)
 *
 * Toggle behavior: clicking BEFORE marks reviewed; clicking AFTER clears it
 * (allowing the coach to keep editing).
 */

interface MarkAsReviewedControlProps {
  markedAt: string | null;
  saving?: boolean;
  onMark: () => Promise<void> | void;
  onClear: () => Promise<void> | void;
}

export function MarkAsReviewedControl({
  markedAt,
  saving,
  onMark,
  onClear,
}: MarkAsReviewedControlProps) {
  if (markedAt) {
    return (
      <Group
        gap={6}
        align="center"
        wrap="nowrap"
        component="button"
        onClick={() => onClear()}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: saving ? 'wait' : 'pointer',
          padding: '6px 10px',
          borderRadius: 6,
        }}
        title="Click to undo and continue editing"
      >
        <ThemeIcon variant="filled" color="medleyGreen" radius="xl" size="sm">
          <Check size={14} />
        </ThemeIcon>
        <Text size="sm" fw={500} c="medleyGreen">
          Marked As Reviewed
        </Text>
      </Group>
    );
  }

  return (
    <Button
      variant="default"
      size="sm"
      onClick={() => onMark()}
      loading={saving}
      radius="md"
    >
      Mark As Reviewed
    </Button>
  );
}
